import { useContext } from 'react';
import UnitContext from '../contexts/unit.context';

export default function useUnit() {
  return useContext(UnitContext);
}
